module.exports = __webpack_public_path__ + "img/fi-toasts-800x527.ce275a9d.jpg";